import { useTranslation } from 'react-i18next';

export default function ViewMaterialButton(props: {
  templateMaterialUrl: string;
  buttonStyleClass?: string;
}) {
  const [t] = useTranslation(['chatroom']);

  return (
    <button
      className={
        props.buttonStyleClass
          ? `${props.buttonStyleClass}`
          : 'py-2 w-full border-2 border-solid border-[#38539A] rounded-3xl text-sm text-[#38539A] bg-white'
      }
      onClick={() => {
        window.location.assign(props.templateMaterialUrl);
      }}
    >
      {t('activity_templates_material_url_view', '查看素材')}
    </button>
  );
}
